import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import UsageLimiter from '../../components/usage-limiter/UsageLimiter';
import Storage from '../../services/Storage';

export default function UsageLimiterPage() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])
  return (
    <UsageLimiter />
  );
}